import { userInfoSync } from 'hub-http/userInfo';
import Routes from 'ContentUtils/Routes';
import { CATEGORY_IDS } from 'ContentUtils/constants/Categories';
import PortalIdParser from 'PortalIdParser';
import enviro from 'enviro';
export const checkIsWebInteractive = guid => !isNaN(Number(guid));
export const openWebInteractivesEditor = guid => {
  window.open(Routes.inpageEdit(guid, CATEGORY_IDS.WEB_INTERACTIVE), '_blank');
};
export const checkHasAccessToCtas = () => {
  const {
    user
  } = userInfoSync();
  const hasLegacyCtasAccess = user.scopes.includes('cta-access');
  const hasWebInteractivesAccess = user.scopes.includes('calls-to-action-read');
  return hasLegacyCtasAccess || hasWebInteractivesAccess;
};
export const getWebInteractiveImageUrl = contentId => {
  const isProd = enviro.isProd();
  const portalId = PortalIdParser.get();
  const hublet = enviro.getHublet();
  const domainSuffix = isProd ? '' : 'qa';

  if (hublet === 'na1') {
    return `https://local.hubspotqa.com/web-interactives/public/v1/embed/cta-image/${contentId}?portalId=${portalId}`;
  }

  return `https://cta-${hublet}.hubspot${domainSuffix}.com/web-interactives/public/v1/embed/cta-image/${contentId}?portalId=${portalId}`;
};